export function tipContainer() {
    return {
        restrict: 'E',
        scope: {
            resource: '=', // a function to get the items or the items themselves
            label: '@',
            image: '@?',
        },
        replace: true,
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/tipContainer.html',
        controller: [
            '$scope', function($scope) {
                $scope.isLoading = true;

                if (typeof $scope.resource === 'function') {
                    $scope.resource().then(function(d) {
                        $scope.isLoading = false;
                        $scope.data = d;
                    });
                } else {
                    $scope.isLoading = false;
                    $scope.data = $scope.resource;
                }
            },
        ],
    };
}

